 <template>
  <div class="app-aftersales">
    <div class="aftersaleshead">
      <div class="container">
        <div class="row">
          <div class="col-sm-6 col-md-6 col-lg-6" style="padding-right:8%;padding-top:7%">
            <h6>Choose the service you require</h6>
            <h3 class="contacttitle">After-Sales Service</h3>
            <p>Whether your vehicle needs servicing or additional maintenance, our dealership takes pride in ensuring you receive a professional and swift service.</p>
          </div>
          <div class="col-sm-6 col-md-6 col-lg-6">
            <div class="hero-image">
              <img :src="after" width="auto" height="300px" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="aftersales" style="padding-top:2rem">
      <div class>
        <div>
          <b-tabs content-class align="center">
            <b-tab title="Workshop" active>
              <div class="tabcontent">
                <div class="container">
                  <div class="row py-5">
                    <div class="col-12 col-md-4 col-lg-4 first">
                      <h5>
                        We offer
                        <span style="color:#FF7939">Service or Maintenance</span>
 based on manufacturers’ recommendation and/or intended duration.
                        <!-- We offer
                        <span>specific maintenance</span> based on your vehicle's age, type and condition.-->
                      </h5>
                      <p>
                        Our workshop is equipped with the state-of-the-art equipment and high-standard quality control procedures, to ensure excellent delivery.
                        <el-button
                          type="info"
                          style="border: 1.5px solid #FF7939;background:transparent; color:#000; margin-top:1rem"
                          @click="contact"
                        >
                          BOOK AN APPOINTMENT
                          <i class="el-icon-arrow-right" style="padding-left:5%"></i>
                        </el-button>
                        <!-- Whether it be routine servicing, replacing maintenance items, or performing repairs, at
                        <span>Silver Star Auto</span> we offer you a complete solution. We’ll give your vehicle exactly what it needs, no more, no less-->
                      </p>
                    </div>

                    <div class="col-12 col-md-8 col-lg-8 features">
                      <div class="row">
                        <div class="aftercontent" style>
                          <div class="col-12 col-md-8 col-lg-4">
                            <a
                              class="btn btn-link afterdes"
                              data-toggle="collapse"
                              href="#multiCollapseExample1"
                              role="button "
                              aria-expanded="false"
                              aria-controls="multiCollapseExample1"
                              style
                            >
                              Express Maintenance
                              <span>
                                <i
                                  class="el-icon-arrow-right el-icon-right"
                                  style="color:#E63E16; margin-left:5%"
                                ></i>
                              </span>
                            </a>
                            <div class="col" style="margin-top:1rem">
                              <div class="collapse multi-collapse" id="multiCollapseExample1">
                                <div class="pop">
                                  With express maintenance, servicing is done within an hour.The following items are mostly replaced under express maintenance:
                                  <br />

                                  <!-- <br />Some of these jobs include:<br> -->
                                  • Engine oil
                                  <br />• Oil filter
                                  <br />• Air-conditioning filter
                                  <br />• Wiper blades, etc.
                                  <br />
                                  <!-- - Wiper Blade Replacement<br> -->
                                  <h6>Recommendations</h6>Mercedes-Benz Petrol cars - 10,000 km/ once a year, whichever comes first
                                  <br />
                                  <br />Mercedes-Benz Diesel cars – 6000 km/ twice a year, whichever comes first
                                  <br />
                                  <br />Peugeot - 10,000 km/ once a year, whichever comes first
                                  <br />
                                  <br />Peugeot Pickup - 10,000 km/ every 6 months, whichever comes first
                                  <br />
                                  <br />Citroën - 10,000 km/ once a year, whichever comes first
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-md-8 col-lg-4">
                            <a
                              class="btn btn-link afterdes"
                              data-toggle="collapse"
                              href="#multiCollapseExample2"
                              role="button "
                              aria-expanded="false"
                              aria-controls="multiCollapseExample2"
                              style
                            >
                              Routine Maintenance
                              <span>
                                <i
                                  class="el-icon-arrow-right el-icon-right"
                                  style="color:#E63E16; margin-left:5%"
                                ></i>
                              </span>
                            </a>
                            <div class="col" style="margin-top:1rem">
                              <div class="collapse multi-collapse" id="multiCollapseExample2">
                                <div class="pop">
                                  <!-- Major repairs consist of a series of maintenance procedures that are performed to restore a vehicle’s performance. -->
                                  Routine maintenance involves repairs such as:
                                  <br />• Comprehensive servicing
                                  <br />• Suspension repairs
                                  <br />• Transmission servicing
                                  <br />• Air-condition repairs, etc.
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-md-8 col-lg-4">
                            <a
                              class="btn btn-link afterdes"
                              role="button"
                              data-toggle="collapse"
                              data-target="#multiCollapseExample3"
                              aria-expanded="false"
                              aria-controls="multiCollapseExample3"
                              style="margin-right:0rem"
                            >
                              Breakdown Maintenance
                              <i
                                class="el-icon-arrow-right el-icon-right"
                                style="color:#E63E16; margin-left:5%"
                              ></i>
                            </a>
                            <div class="col">
                              <div class="collapse multi-collapse" id="multiCollapseExample3">
                                <div class="pop">
                                  Breakdown maintenance involves diagnosis repairs carried out on-site, and mostly include difficult starting etc
                                  <!-- <br />
                                  <br />• Difficult starting
                                  <br />• Engine overheating
                                  <br />• Clutch and transmission faults
                                  <br />• Electrical/electronic faults
                                  <br />-->
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- second row -->

                      <div class="row" style="padding-top:2rem">
                        <div class="aftercontent">
                          <div class="col-12 col-md-8 col-lg-4">
                            <a
                              class="btn btn-link afterdes"
                              data-toggle="collapse"
                              href="#multiCollapseExample4"
                              role="button "
                              aria-expanded="false"
                              aria-controls="multiCollapseExample4"
                              style
                            >
                              Towing Services
                              <span>
                                <i
                                  class="el-icon-arrow-right el-icon-right"
                                  style="color:#E63E16; margin-left:5%"
                                ></i>
                              </span>
                            </a>
                            <div class="col" style="margin-top:1rem">
                              <div class="collapse multi-collapse" id="multiCollapseExample4">
                                <div
                                  class="pop"
                                >Towing services are available for all breakdown vehicles needing to be towed to our respective workshops.</div>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-md-8 col-lg-4">
                            <a
                              class="btn btn-link afterdes"
                              data-toggle="collapse"
                              href="#multiCollapseExample5"
                              role="button "
                              aria-expanded="false"
                              aria-controls="multiCollapseExample5"
                              style
                            >
                              Body & Repair
                              <span>
                                <i
                                  class="el-icon-arrow-right el-icon-right"
                                  style="color:#E63E16; margin-left:5%"
                                ></i>
                              </span>
                            </a>
                            <div class="col" style="margin-top:1rem">
                              <div class="collapse multi-collapse" id="multiCollapseExample5">
                                <div
                                  class="pop"
                                >We have the state of the art body and paint facility to take care of all your body and paint needs</div>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-md-8 col-lg-4">
                            <a
                              class="btn btn-link afterdes"
                              role="button"
                              data-toggle="collapse"
                              data-target="#multiCollapseExample6"
                              aria-expanded="false"
                              aria-controls="multiCollapseExample6"
                              style
                            >
                              Technical Report
                              <i
                                class="el-icon-arrow-right el-icon-right"
                                style="color:#E63E16; margin-left:5%"
                              ></i>
                            </a>
                            <div class="col">
                              <div class="collapse multi-collapse" id="multiCollapseExample6">
                                <div
                                  class="pop"
                                >We undertake technical assessment for Mercedes-Benz, Peugeot and Citroën vehicles.</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab title="Spare Parts">
              <div class="tabcontent">
                <div class="container">
                  <div class="row py-5">
                    <div class="col-12 col-md-4 col-lg-4 first">
                      <h5 style="font-size: 15px;letter-spacing: 0.15px;">
                        The company strives to give to our cherished customers the best vehicle life experience by providing
                        <span
                          style="color:#FF7939"
                        >genuine & essential</span> parts. There is one year warranty for spare parts replaced excluding servicing parts and consumables. Terms & conditions apply in line with manufacturer warranty procedure.
                        <el-button
                          type="info"
                          style="border: 1.5px solid #FF7939;background:transparent; color:#000 !important; margin-top:1rem"
                          @click="contact"
                        >
                          BOOK AN APPOINTMENT
                          <i class="el-icon-arrow-right" style="padding-left:5%"></i>
                        </el-button>
                        <!-- Silver Star Auto Limited strives to give you the best vehicle life and ownership experience by providing you with
                        <span
                          style="padding:0rem 0.2rem"
                        >essential and genuine</span>Mercedes-Benz, Peugeot and Citroën spare parts to meet all repair and maintenance needs.
                        Spare parts warranty is 1 year, excluding consumable parts.
                        For further information, you may read more about your warranty terms and conditions in the warranty documents.-->
                      </h5>
                      <!-- <p>The warranty starts from the first date of registration of the vehicle. Any component defect from production shall be replaced in accordance with the manufacturer’s warranty terms and conditions.</p> -->
                    </div>

                    <div class="col-12 col-md-8 col-lg-8 features">
                      <div class="row" style="padding-top:2rem">
                        <div class="aftercontent">
                          <div class="col-12 col-md-8 col-lg-4">
                            <a
                              class="btn btn-link afterdes"
                              data-toggle="collapse"
                              href="#multiCollapseExample7"
                              role="button "
                              aria-expanded="false"
                              aria-controls="multiCollapseExample7"
                              style
                            >
                              Batteries
                              <span>
                                <i
                                  class="el-icon-arrow-right el-icon-right"
                                  style="color:#E63E16; margin-left:5%"
                                ></i>
                              </span>
                            </a>
                            <div class="col" style="margin-top:1rem">
                              <div class="collapse multi-collapse" id="multiCollapseExample7">
                                <div class="pop">
                                  <!-- <h6>Energizer</h6>We are the sole distributers of Energizer car batteries in Ghana. Energizer offers you an innovative, tried and tested battery that is high in quality, reliability and performance -->
                                  Energizer batteries are high in quality, reliability and performance. Energizer offers you an innovative, tried and tested battery that is high in quality, reliability and performance
                                  <!-- <br />
                                  <br />The battery ranges from:
                                  <br />• Energizer Premium AGM
                                  <br />• Energizer Premium EFB
                                  <br />• Energizer Premium
                                  <br />• Energizer Plus
                                  <br />• Energizer Commercial Vehicle Batteries
                                  <br />-->
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-md-8 col-lg-4">
                            <a
                              class="btn btn-link afterdes"
                              data-toggle="collapse"
                              href="#multiCollapseExample8"
                              role="button "
                              aria-expanded="false"
                              aria-controls="multiCollapseExample8"
                              style
                            >
                              Oils
                              <span>
                                <i
                                  class="el-icon-arrow-right el-icon-right"
                                  style="color:#E63E16; margin-left:5%"
                                ></i>
                              </span>
                            </a>
                            <div class="col" style="margin-top:1rem">
                              <div class="collapse multi-collapse" id="multiCollapseExample8">
                                <div class="pop">
                                  <!-- Engine oil plays many roles in allowing an engine to run properly over time. A quality engine oil ensures longer engine lifespan, proper running of the engine, and decreased fuel consumption and CO2 emissions. This is why we offer only the highest quality engine oils for your vehicle. -->
                                  Oil plays a major role in the performance and health of an engine. A quality engine oil ensures longer engine lifespan, proper running of the engine, and decreased fuel consumption and CO
                                  <span
                                    style="vertical-align:sub; font-size:10px"
                                  >2</span> emissions. This is why we offer only the highest quality engine oils for your vehicle.
                                  <br />
                                  <br />Our brands include:
                                  <br />• Motul Oil
                                  <br />• Power Oil
                                  <br />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab title="Warranty">
              <div class="tabcontent">
                <div class="container">
                  <div class="row py-5">
                    <div class="col-12 col-md-4 col-lg-4 first">
                      <h5>
                        With the exception of express or maintenance repairs, other repair works come with one year warranty for both spare parts and labour. Terms & conditions apply.
                        <br />
                        <el-button
                          type="info"
                          style="border: 1.5px solid #FF7939;background:transparent; color:#000; margin-top:1rem"
                          @click="contact"
                        >
                          CONTACT US
                          <i class="el-icon-arrow-right" style="padding-left:5%"></i>
                        </el-button>
                        
                      </h5>
                   
                    </div>

                    <div class="col-12 col-md-8 col-lg-8 features">
                      <div class="row" style="padding-top:2rem">
                        <div class="aftercontent">
                          <div class="col-12 col-md-8 col-lg-4">
                            <a
                              class="btn btn-link afterdes"
                              data-toggle="collapse"
                              href="#multiCollapseExample9"
                              role="button "
                              aria-expanded="false"
                              aria-controls="multiCollapseExample9"
                              style
                            >
                              Mercedes-Benz
                              <span>
                                <i
                                  class="el-icon-arrow-right el-icon-right"
                                  style="color:#E63E16; margin-left:5%"
                                ></i>
                              </span>
                            </a>
                            <div class="col" style="margin-top:1rem">
                              <div class="collapse multi-collapse" id="multiCollapseExample9">
                                <div class="pop">
                                  <h6>Passenger Cars</h6>24 months without mileage limitation from date of delivery to customer
                                  <br />
                                  <br />

                                  <h6>Trucks</h6>12 months from date of delivery without mileage limitation.
                                  <br />
                                  <br />

                                  <h6>Trucks Powertrain</h6>36 months or 250,000 km from date of delivery, whichever comes first.
                                  <br />
                                  <br />

                                  <h6>Vans</h6>24 months or 200,000 km from the date of first registration, whichever comes first.
                                  <br />
                                  <br />

                                  <h6>Buses</h6>12 months or 200,000 km from the date of first registration, whichever comes first
                                  <br />
                                  <br />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-md-8 col-lg-4">
                            <a
                              class="btn btn-link afterdes"
                              data-toggle="collapse"
                              href="#multiCollapseExample10"
                              role="button "
                              aria-expanded="false"
                              aria-controls="multiCollapseExample10"
                              style
                            >
                              Peugeot
                              <span>
                                <i
                                  class="el-icon-arrow-right el-icon-right"
                                  style="color:#E63E16; margin-left:5%"
                                ></i>
                              </span>
                            </a>
                            <div class="col" style="margin-top:1rem">
                              <div class="collapse multi-collapse" id="multiCollapseExample10">
                                <div class="pop">3 Years or 100,000km, whichever comes first.</div>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-md-8 col-lg-4">
                            <a
                              class="btn btn-link afterdes"
                              data-toggle="collapse"
                              href="#multiCollapseExample11"
                              role="button "
                              aria-expanded="false"
                              aria-controls="multiCollapseExample11"
                              style
                            >
                              Citroën
                              <span>
                                <i
                                  class="el-icon-arrow-right el-icon-right"
                                  style="color:#E63E16; margin-left:5%"
                                ></i>
                              </span>
                            </a>
                            <div class="col" style="margin-top:1rem">
                              <div class="collapse multi-collapse" id="multiCollapseExample11">
                                <div class="pop">3 Years or 100,000km, whichever comes first.</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab title="Service Contract">
              <div class="tabcontent">
                <div class="container">
                  <div class="row py-5">
                    <div class="col-12 col-md-4 col-lg-4 firsts">
                      <h5>
                      No one knows your vehicle better than we do. Our expertly trained technicians use <span style="color: #FF7939"> Genuine parts</span> and help make life less complicated with service that’s both professional and efficient.
                      
                      </h5>
                     
                        <el-button
                          type="info"
                          style="border: 1.5px solid #FF7939;background:transparent; color:#000; margin-top:1rem"
                          @click="contact"
                        >
                          CONTACT US
                          <i class="el-icon-arrow-right" style="padding-left:5%"></i>
                        </el-button>
                     
                    </div>
                      <div class="col-12 col-md-8 col-lg-8 features">
                      <div class="row" style="padding-top:2rem">
                        <div class="aftercontent">
                          <div class="col-12 col-md-8 col-lg-4">
                            <a
                              class="btn btn-link afterdes"
                              data-toggle="collapse"
                              href="#multiCollapseExample12"
                              role="button "
                              aria-expanded="false"
                              aria-controls="multiCollapseExample12"
                              style
                            >
                              Mercedes-Benz
                              <span>
                                <i
                                  class="el-icon-arrow-right el-icon-right"
                                  style="color:#E63E16; margin-left:5%"
                                ></i>
                              </span>
                            </a>
                            <div class="col" style="margin-top:1rem">
                              <div class="collapse multi-collapse" id="multiCollapseExample12">
                                <div class="pop">
                                  For your Mercedes-Benz Passenger vehicles, we offer you 1-2 years service contracts, ensuring stress-free maintenance whenever you need it.
                                  <br>
                                  <br>
                                 

                                <!-- If you are a commercial vehicle owner, this is planned with you in mind to ensure that you maximize profits by reducing your down time and costs. -->
                                  <br>
                                  <br>
                                 

                                  Your peace of mind is guaranteed as we preorder and reserve essential parts solely for your vehicle, intended to cover routine and breakdown maintenance needs.
                                  <br>
                                  <br>

                                 

                                 
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-md-8 col-lg-4">
                            <a
                              class="btn btn-link afterdes"
                              data-toggle="collapse"
                              href="#multiCollapseExample13"
                              role="button "
                              aria-expanded="false"
                              aria-controls="multiCollapseExample13"
                              style
                            >
                              Peugeot
                              <span>
                                <i
                                  class="el-icon-arrow-right el-icon-right"
                                  style="color:#E63E16; margin-left:5%"
                                ></i>
                              </span>
                            </a>
                            <div class="col" style="margin-top:1rem">
                              <div class="collapse multi-collapse" id="multiCollapseExample13">
                                <div class="pop">For your Peugeot vehicles, we offer you 1-3 years service contracts, ensuring stress-free maintenance whenever you need it.
                                  <br>
                                   <br>
                                   Your peace of mind is guaranteed as we preorder and reserve essential parts solely for your vehicle, intended to cover routine and breakdown maintenance needs
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-md-8 col-lg-4">
                            <a
                              class="btn btn-link afterdes"
                              data-toggle="collapse"
                              href="#multiCollapseExample14"
                              role="button "
                              aria-expanded="false"
                              aria-controls="multiCollapseExample14"
                              style
                            >
                              Citroën
                              <span>
                                <i
                                  class="el-icon-arrow-right el-icon-right"
                                  style="color:#E63E16; margin-left:5%"
                                ></i>
                              </span>
                            </a>
                            <div class="col" style="margin-top:1rem">
                              <div class="collapse multi-collapse" id="multiCollapseExample14">
                                <div class="pop">For your Citroën vehicles, we offer you 1-3 years service contracts, ensuring stress-free maintenance whenever you need it.
                                  <br>
                                  <br>
                                  Your peace of mind is guaranteed as we preorder and reserve essential parts solely for your vehicle, intended to cover routine and breakdown maintenance needs
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>

    <div class="bg-dark" style="padding-top:3rem">
      <div class="container">
        <core style="border-top:1px solid rgba(255, 255, 255, .24)"></core>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import CoreValues from "../components/Core.vue";
var after = require("../assets/img/after.svg");

export default {
  name: "After-Sales",
  components: {
    core: CoreValues
  },
  data() {
    return { after: after };
  },
  metaInfo() {
    return {
      title: "After-Sales"
    };
  },
  computed: {},
  methods: {
    contact() {
      this.$router.push("/contact");
    }
  },
  created() {}
};
</script>
